<template>
	<div class="about_en">
		<div class="about_en_pc" v-if="!isPhone">
			<div class="aben_head">
				<img class="ah_zt" v-if="abobj.image" :src="staticImg+abobj.image">
				<div class="ah_zzc">
					<img src="@/images/about/zzc.png">
				</div>
			</div>
			<div class="com_pro">
				<div class="flex2 com_pro_tit">
					<img src="@/images/about/en_left.png">
					<span>Company Profile</span>
					<img src="@/images/about/en_right.png">
				</div>
				<div class="com_pro_text" data-aos="fade-up" v-html="compInfo.content"></div>
				<!-- <div class="com_pro_img flex2">
					<img data-aos="fade-up" v-for="(item,index) in compImg" :key="index" :src="item">
				</div> -->
			</div>
			<div class="mile_box">
				<div class="flex2 com_pro_tit">
					<img src="@/images/about/en_left.png">
					<span>Glorious Milestones</span>
					<img src="@/images/about/en_right.png">
				</div>
				<div class="ml_list">
					<div class="ml_sty1 flex3">
						<div class="mlt_d1" data-aos="fade-up" v-for="item in slt1" :key="item.id">
							<div class="mlt_d1_img">
								<img :src="staticImg+item.image">
							</div>
							<div class="mlt_d1_tit">
								<span>{{ item.title }}</span>
							</div>
							<div class="mlt_d1_desc">{{ item.desc }}</div>
						</div>
					</div>
					<div class="ml_sty1 flex3">
						<div class="mlt_d1" data-aos="fade-up" v-for="item in slt2" :key="item.id">
							<div class="mlt_d1_img">
								<img :src="staticImg+item.image">
							</div>
							<div class="mlt_d1_tit">
								<span>{{ item.title }}</span>
							</div>
							<div class="mlt_d1_desc">{{ item.desc }}</div>
						</div>
					</div>
					<div class="ml_sty1 flex3">
						<div class="mlt_d1 zdsty" data-aos="fade-up" v-for="item in slt3" :key="item.id">
							<div class="mlt_d1_img zdsty_img">
								<img :src="staticImg+item.image">
							</div>
							<div class="mlt_d1_tit">
								<span>{{ item.title }}</span>
							</div>
							<div class="mlt_d1_desc">{{ item.desc }}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="com_golr">
				<div class="golr_tit">Glorious Milestones</div>
				<div class="golr_box flex1">
					<div class="golr_left flex2">
						<swiper class="hn_swiper" ref="lcbSwiper" :options="swiperOptions" @slideChange="onSlideChange57">
							<swiper-slide class="hn_slide" v-for="(item, index) in actSwiper" :key="index">
								<div class="hn_slide_img flex2">
									<img v-if="item.images" data-aos="zoom-in" :src="staticImg + item.images" />
								</div>
								<p class="hn_slide_p">{{ item.contjs}}</p>
							</swiper-slide>
						</swiper>
						<img @click="swiperChange(1)" @mouseenter="overleft=true" @mouseout="overleft=false" class="jt_zuo"
							:src="overleft?leftimg2:leftimg1">
						<img @click="swiperChange(2)" @mouseenter="overright=true" @mouseout="overright=false" class="jt_you"
							:src="overright?rightimg2:rightimg1">
						<div class="sp_num">
							<span>{{ spAct+1 }}</span>
							<span>/{{actSwiper.length||1}}</span>
						</div>
					</div>
					<div class="golr_right">
						<div class="hn_box">
							<ul class="hn_ul" ref="listRef">
								<li class="hn_li" :class="actIndex == index ? 'ho_act11' : ''" v-for="(item, index) in lcblist"
									:key="index" @click="selYear(index)">
									{{ item.year }}
								</li>
							</ul>
						</div>
						<p><i @click="handUp" class="hn_shang el-icon-arrow-up"></i></p>
						<p><i @click="handDown" class="hn_xia el-icon-arrow-down"></i></p>
					</div>
				</div>
			</div>
		</div>
		<div class="about_en_ph" v-if="isPhone">
			<enHeader2 :searchShow="true"></enHeader2>
			<div class="aben_head">
				<img src="@/images/about/ban2.png">
				<div class="ah_zzc"></div>
			</div>
			<div class="com_pro">
				<div class="flex2 com_pro_tit">
					<img src="@/images/about/en_left.png">
					<span>Company Profile</span>
					<img src="@/images/about/en_right.png">
				</div>
				<div class="com_pro_text" data-aos="fade-up" v-html="compInfo.content"></div>
				<!-- <div class="com_pro_img" v-if="compImg">
					<img data-aos="fade-up" v-for="(item,index) in compImg" :key="index" :src="item">
				</div> -->
			</div>
			<div class="mile_box">
				<div class="flex2 com_pro_tit">
					<img src="@/images/about/en_left.png">
					<span>Glorious Milestones</span>
					<img src="@/images/about/en_right.png">
				</div>
				<div class="ml_list">
					<div class="ml_sty1">
						<div class="mlt_d1" data-aos="fade-up" v-for="item in sevenlist" :key="item.id">
							<div class="mlt_d1_img">
								<img :src="staticImg+item.image">
							</div>
							<div class="mlt_d1_tit">
								<span>{{ item.title }}</span>
							</div>
							<div class="mlt_d1_desc">{{ item.desc }}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="com_golr">
				<div class="flex2 com_pro_tit">
					<img src="@/images/about/en_left.png">
					<span>Company Honors</span>
					<img src="@/images/about/en_right.png">
				</div>
				<div class="sel_year flex2">
					<span class="ye_sp" v-if="phsw.length">{{phsw[phswact].year}}</span>
				</div>
				<div class="golr_box" v-if="phsw.length">
					<div class="hn_wrap">
						<swiper class="hn_swiper" ref="phSwiper" :options="swiperOptions46" @slideChange="onSlideChange60">
							<swiper-slide class="hn_slide" v-for="(item, index) in phsw" :key="index">
								<div class="hn_slide_img flex2">
									<img :src="staticImg + item.images" />
								</div>
								<div class="hn_slide_p">{{item.contjs}}</div>
							</swiper-slide>
							<!-- <div class="swiper-pagination pagination46" slot="pagination"></div> -->
						</swiper>
						<div class="pagination46">
							<span class="moren" :class="phswact==index?'jihuo':''" v-for="(item, index) in phsw" :key="index"></span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			staticImg: this.$staticImg,
			isPhone: this.$isMobile,
			abobj: {},
			compInfo: {},
			compImg: [],
			lcblist: [],
			actIndex: 0,
			swiperOptions: {},
			swiperOptions46: {
				// 分页器配置
				// pagination: {
				// 	el: ".pagination46",
				// 	clickable: true,
				// },
			},
			overleft: false,
			overright: false,
			actSwiper: [],
			phsw: [],//手机端里程碑用
			phswact: 0,
			leftimg1: require("@/images/about/ab_left1.png"),
			leftimg2: require("@/images/about/ab_left2.png"),
			rightimg1: require("@/images/about/ab_right1.png"),
			rightimg2: require("@/images/about/ab_right2.png"),
			spAct: 0,
			selyear: '',
			scrollStep: 46,
			sevenlist: [],
			slt1: [],
			slt2: [],
			slt3: [],
		}
	},
	created() {
		this.eprofile();
		this.enIndex();
		this.eglorious();
		this.enlcb();
	},
	methods: {
		// 基础信息
		async enIndex() {
			const res = await this.$api.enIndex();
			if (res.code == 1) {
				var data6 = res.data;
				for (let i = 0; i < data6.length; i++) {
					if (data6[i].id == 2) {
						this.abobj = data6[i];
					}
				}
			}
		},
		async enlcb() {
			const res = await this.$api.enlcb();
			if (res.code == 1) {
				this.sevenlist = res.data;
				this.slt1 = this.sevenlist.filter((item, index) => index < 2);
				this.slt2 = this.sevenlist.filter((item, index) => index == 2 || index == 3);
				this.slt3 = this.sevenlist.filter((item, index) => index == 4 || index == 5 || index == 6);
			}
		},
		async eprofile() {
			const res = await this.$api.eprofile();
			if (res.code == 1) {
				this.compInfo = res.data;
				for (let i = 0; i < this.compInfo.images.length; i++) {
					this.compImg.push(this.$staticImg + this.compInfo.images[i])
				}
			}
		},
		// 里程碑
		async eglorious() {
			const res = await this.$api.eglorious();
			if (res.code == 1) {
				this.lcblist = res.data;
				this.actSwiper = this.lcblist[0].info;
				this.selyear = this.lcblist[0].year;
				// 手机端用
				for (let i = 0; i < this.lcblist.length; i++) {
					this.phsw = this.phsw.concat(this.lcblist[i].info);
				}
			}
		},
		selYear(index) {
			this.actIndex = index;
			this.actSwiper = {};
			setTimeout(() => {
				this.actSwiper = this.lcblist[this.actIndex].info;
			}, 50);
		},
		handUp() {
			const list = this.$refs.listRef;
			list.scrollTo({
				top: list.scrollTop - this.scrollStep,
				behavior: 'smooth'
			});
		},
		handDown() {
			const list = this.$refs.listRef;
			list.scrollTo({
				top: list.scrollTop + this.scrollStep,
				behavior: 'smooth'
			});
		},
		swiperChange(a) {
			if (a == 1) {
				if (this.spAct > 0) {
					this.spAct--;
					this.$refs.lcbSwiper.$swiper.slideTo(this.spAct);
				}
			}
			if (a == 2) {
				if (this.spAct < (this.actSwiper.length - 1)) {
					this.spAct++;
					this.$refs.lcbSwiper.$swiper.slideTo(this.spAct);
				}
			}
		},
		onSlideChange57() {
			var swiper23 = this.$refs.lcbSwiper.$swiper;
			const currentIndex = swiper23.realIndex;
			this.spAct = currentIndex;
		},
		onSlideChange60() {
			var swiper24 = this.$refs.phSwiper.$swiper;
			const phIndex = swiper24.realIndex;
			this.phswact = phIndex;
		},
		yearChange(e) {
			this.selyear = e.target.value;
			for (let i = 0; i < this.lcblist.length; i++) {
				if (this.selyear == this.lcblist[i].year) {
					this.actSwiper = this.lcblist[i].info;
				}
			}
		}
	},
}
</script>

<style lang="scss">
@function vw($size) {
	@return $size/1920 * 100vw;
}
.ho_act11 {
	color: #d43235 !important;
	font-size: 20px !important;
}
.about_en {
	/* 自定义指示器容器位置 */
	.pagination46 {
		width: 100%;
		// border: 1px solid red;
	}
	.pagination46 .moren {
		display: inline-block;
		width: 8px;
		height: 8px;
		background-color: #f0ebe5;
		opacity: 1;
		margin: 0 4px;
		border-radius: 50%;
		transition: width 0.5s;
	}
	.jihuo {
		background-color: #ff0000 !important; /* 激活时红色 */
		width: 26px !important;
		border-radius: 10px !important;
	}
	@font-face {
		font-family: "SourceHanSerifCN";
		src: url("../../font/SourceHanSerifCN-Heavy.otf");
	}
	font-family: "SourceHanSerifCN";
	.ah_zzc {
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		right: 0;
		z-index: 1;
		background-color: rgba(0, 38, 81, 0.35);
		img {
			width: 100%;
		}
	}
	.about_en_pc {
		padding-top: 80px;
		min-width: 1000px;
		.aben_head {
			width: 100%;
			position: relative;
            overflow: hidden;
			.ah_zt {
				display: block;
				width: 100%;
			}
		}
		.com_pro_tit {
			margin-bottom: 40px;
			img {
				width: 40px;
			}
			span {
				font-size: 40px;
				font-weight: bold;
				margin: 0 40px;
			}
		}
		.com_pro {
			background-color: #eceaeb;
			padding: 100px 0;
			.com_pro_text {
				width: 1400px;
				margin: 0 auto;
				text-align: left;
			}
			.com_pro_img {
				margin-top: 80px;
				img {
					width: 23.4%;
					height: auto;
					margin-left: 20px;
					&:nth-child(1) {
						margin-left: 0;
					}
				}
			}
		}
		.mile_box {
			background-image: url("../../images/about/mebg.png");
			background-repeat: no-repeat;
			background-size: 100% 100%;
			padding: 100px 0 60px 0;
			background-color: #f1f0f0;
			.ml_list {
				margin-top: 100px;
				.ml_sty1 {
					width: 1400px;
					margin: 0 auto;
					margin-bottom: 60px;
					align-items: flex-start;
					.mlt_d1 {
						width: 660px;
						margin-right: 80px;
						&:nth-last-child(1) {
							margin-right: 0;
						}
						.mlt_d1_img {
							width: 660px;
							height: 340px;
							overflow: hidden;
							img {
								width: 100%;
								transition: transform 0.5s ease;
								cursor: pointer;
								&:hover {
									transform: scale(1.06);
								}
							}
						}
						.mlt_d1_tit {
							margin-top: 32px;
							span {
								display: inline-block;
								width: 126px;
								height: 40px;
								line-height: 44px;
								text-align: center;
								border: 3px solid #c4a156;
								font-size: 20px;
								color: #c4a156;
								font-weight: bold;
							}
						}
						.mlt_d1_desc {
							text-align: left;
							line-height: 2;
							font-size: 14px;
							margin-top: 15px;
						}
					}
					.zdsty {
						width: 420px;
						.zdsty_img {
							width: 420px;
							height: 225px;
							overflow: hidden;
							img {
								width: 100%;
							}
						}
					}
				}
			}
		}
		.com_golr {
			padding: 100px 0 150px 0;
			background-image: url("../../images/about/enbg1.png");
			background-repeat: no-repeat;
			background-size: 100% 100%;
			background-color: #fff;
			.golr_tit {
				font-size: 40px;
				font-weight: bold;
			}
			.golr_box {
				margin: 0 auto;
				margin-top: 127px;
				width: 1400px;
				.golr_left {
					width: 1176px;
					height: 650px;
					position: relative;
					.hn_swiper {
						width: 800px;
						.hn_slide {
							width: 800px;
							.hn_slide_img {
								width: 800px;
								height: 500px;
								overflow: hidden;
								background-image: url("../../images/about/bgf.png");
								background-size: 100% 100%;
								background-repeat: no-repeat;
								border-radius: 10px;
								img {
									height: 500px;
									width: auto;
									transition: transform 0.8s ease;
									&:hover {
										transform: scale(1.06);
									}
								}
							}
							.hn_slide_p {
								margin-top: 35px;
								text-align: left;
								line-height: 32px;
								font-size: 20px;
								font-weight: bold;
							}
						}
					}
					.jt_zuo {
						position: absolute;
						left: 0;
						top: 216px;
						z-index: 9;
						width: 68px;
						cursor: pointer;
					}
					.jt_you {
						position: absolute;
						right: 0;
						top: 216px;
						z-index: 9;
						width: 68px;
						cursor: pointer;
					}
					.sp_num {
						position: absolute;
						right: 0;
						bottom: 20px;
						z-index: 9;
						width: 68px;
						span {
							font-weight: bold;
							&:nth-child(1) {
								font-size: 50px;
							}
							&:nth-child(2) {
								font-size: 25px;
							}
						}
					}
				}
				.golr_right {
					width: 72px;
					padding: 30px 0;
					height: 570px;
					overflow: hidden;
					position: relative;
					box-sizing: border-box;
					.hn_shang {
						position: absolute;
						top: 0;
						left: 0;
						right: 0;
						z-index: 1;
						text-align: center;
						cursor: pointer;
						font-size: 24px;
						color: #333;
						font-weight: 600;
					}
					.hn_xia {
						position: absolute;
						left: 0;
						right: 0;
						text-align: center;
						cursor: pointer;
						bottom: 0;
						font-size: 24px;
						color: #333;
						font-weight: 600;
					}
					.hn_box {
						height: 100%;
						.hn_ul {
							width: 72px;
							overflow-y: auto;
							overflow: hidden;
							height: 100%;
							.hn_li {
								font-weight: 700;
								text-align: center;
								height: auto;
								color: #505050;
								font-size: 18px;
								cursor: pointer;
								padding: 10px 0;
								margin-bottom: 10px;
								&:nth-last-child(1) {
									margin-bottom: 0;
								}
							}
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 1600px) {
		.about_en_pc {
			.com_pro {
				.com_pro_text {
					width: 1076px;
				}
			}
			.mile_box {
				.ml_list {
					.ml_sty1 {
						width: 1076px;
						.mlt_d1 {
							width: 508px;
							margin-right: 60px;
							.mlt_d1_img {
								width: 508px;
								height: 262px;
							}
						}
						.zdsty {
							width: 323px;
							.zdsty_img {
								width: 323px;
								height: 173px;
							}
						}
					}
				}
			}
			.com_golr {
				.golr_box {
					margin-top: 127px;
					width: 1070px;
					.golr_left {
						width: 900px;
						.hn_swiper {
							width: 700px;
							.hn_slide {
								width: 700px;
								.hn_slide_img {
									width: auto;
									height: 500px;
								}
								.hn_slide_p {
									margin-top: 35px;
								}
							}
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 1400px) {
		.about_en_pc {
			.com_pro {
				.com_pro_text {
					width: 940px;
				}
			}
			.mile_box {
				.ml_list {
					.ml_sty1 {
						width: 940px;
						.mlt_d1 {
							width: 440px;
							margin-right: 60px;
							.mlt_d1_img {
								width: 440px;
								height: 227px;
							}
						}
						.zdsty {
							width: 280px;
							.zdsty_img {
								width: 280px;
								height: 150px;
							}
						}
					}
				}
			}
			.com_golr {
				padding: 80px 0 120px 0;
				.golr_box {
					margin-top: 127px;
					width: 940px;
					.golr_left {
						width: 800px;
						.hn_swiper {
							width: 600px;
							.hn_slide {
								width: 600px;
								.hn_slide_img {
									width: auto;
									height: 500px;
								}
								.hn_slide_p {
									margin-top: 35px;
								}
							}
						}
					}
				}
			}
		}
	}
	.about_en_ph {
		padding-top: 1.23rem;
		background-image: url("../../images/bgimg4.png");
		.com_pro_tit {
			margin-bottom: 0.73rem;
			img {
				width: 0.5rem;
			}
			span {
				font-size: 0.5rem;
				font-weight: bold;
				margin: 0 0.26rem;
				padding-bottom: 0.05rem;
			}
		}
		.aben_head {
			width: 100%;
            position: relative;
            overflow: hidden;
			img {
				display: block;
				width: 100%;
			}
		}
		.com_pro {
			padding: 0.9rem 0.8rem;
			.com_pro_text {
				text-align: left;
			}
			.com_pro_img {
				margin-top: 0.73rem;
				img {
					width: 100%;
					display: block;
					margin-bottom: 0.73rem;
				}
			}
		}
		.mile_box {
			.ml_list {
				padding: 0.3rem 0.8rem 0.6rem 0.8rem;
				.ml_sty1 {
					.mlt_d1 {
						margin-bottom: 0.8rem;
						.mlt_d1_img {
							img {
								width: 100%;
							}
						}
						.mlt_d1_tit {
							margin-top: 0.5rem;
							span {
								display: inline-block;
								width: 2.4rem;
								height: 0.88rem;
								line-height: 0.88rem;
								text-align: center;
								border: 3px solid #c4a156;
								font-size: 0.5rem;
								color: #c4a156;
								font-weight: bold;
							}
						}
						.mlt_d1_desc {
							text-align: left;
							line-height: 2;
							font-size: 0.35rem;
							margin-top: 0.35rem;
						}
					}
				}
			}
		}
		.com_golr {
			padding: 1.3rem 0.5rem;
			background-image: url("../../images/about/enbg3.png");
			background-repeat: no-repeat;
			background-size: 100%;
			.sel_year {
				.ye_sp {
					font-size: 20px;
					color: #d43236;
					font-weight: bold;
					border-bottom: 2px solid #d43236;
				}
			}
			.golr_box {
				margin-top: 1rem;
				padding: 0 0.3rem;
				.hn_wrap {
					position: relative;
					.hn_swiper {
						width: 100%;
						.hn_slide {
							width: 100%;
							.hn_slide_img {
								width: 100%;
								height: 7.3rem;
								background-image: url("../../images/about/enbg4.png");
								background-repeat: no-repeat;
								background-size: cover;
								border-radius: 0.5rem;
								img {
									width: 90%;
								}
							}
							.hn_slide_p {
								margin-top: 0.5rem;
								text-align: left;
								line-height: 0.7rem;
								font-size: 0.35rem;
								font-weight: bold;
								min-height: 3.8rem;
							}
						}
					}
				}
			}
		}
	}
}
</style>